import React from "react"
import FontIcon from "material-ui/FontIcon"
import IconButton from "material-ui/IconButton"
import TaskItem from "./TaskItem"
import TaskEdit from "./TaskEdit"
import autobind from "class-autobind"
import { IPositionTask } from "../../../models"
interface IProps {
    tasks: IPositionTask[]
    title: string
    ordered?: boolean
    readonly?: boolean
    handleAddNewItem(newItem: IPositionTask): void
    onDeleteRequest(task: IPositionTask): void
}
interface IState {
    showAddTaskControl: boolean
}

export default class TaskList extends React.Component<IProps, IState> {
    constructor(props) {
        super(props)
        this.state = {
            showAddTaskControl: false
        }
        autobind(this)
    }

    render() {
        const tasks = this.props.tasks ? this.props.tasks : []
        return (
            <div className="TaskList">
                {this.props.title &&
                    <h4>{this.props.title}</h4>
                }
                <div style={{ display: "flex", flexWrap: "wrap" }}>
                    {tasks.map((task, i) =>
                        <TaskItem
                            key={i}
                            ordered={this.props.ordered}
                            order={i + 1}
                            code={task.Code}
                            name={task.Name}
                            index={i}
                            onDeleteRequest={() => this.props.onDeleteRequest(task)}
                            readonly={this.props.readonly}
                        />
                    )}
                    {!this.state.showAddTaskControl && !this.props.readonly &&
                        <IconButton
                            data-intercom-target={"Positions-TaskChip-Btn-AddTask"}
                            style={{ height: 35, padding: 0, margin: 0, display: "inline-block" }}
                            onTouchTap={() => this.setState({ showAddTaskControl: true })}
                        >
                            <FontIcon className="fa fa-plus-circle" />
                        </IconButton>
                    }
                    {this.state.showAddTaskControl &&
                        <div style={{ display: "inline-block" }}>
                            <TaskEdit
                                handleSave={newItem => {
                                    this.setState({ showAddTaskControl: false })
                                    this.props.handleAddNewItem(newItem)
                                }}
                            />
                        </div>
                    }
                </div>
            </div>
        )
    }
}
